/* eslint-disable flowtype/no-types-missing-file-annotation */
import {SVGIcon} from '@homeaway/react-svg';
import {TOUR_360__24} from '@homeaway/svg-defs';
import {debounce} from 'lodash';
import React from 'react';

import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import {VIRTUAL_TOUR_BADGE_EXPANDED} from '../../utils/hitEdapUtils';

import './VirtualTourBadge.less';

import {BadgeShape} from '../Hit/Hit';

const handleMouseEnter = debounce((virtualTourId) => {
    trigger(GENERIC_EVENT, {
        eventaction: 'hover virtual tour badge'
    });
    trigger(VIRTUAL_TOUR_BADGE_EXPANDED, {
        tourid: virtualTourId,
        action_location: 'search'
    });
}, 100);

export type Props = {
    badge: BadgeShape;
    detailPageUrl?: string;
    onBadgeClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export function VirtualTourBadge(props: Props) {
    const {badge, detailPageUrl, onBadgeClick, tourId} = props;

    return (
        <a
            className="VirtualTourBadge"
            onMouseEnter={handleMouseEnter.bind(null, tourId)}
            role="presentation"
            target="_blank"
            href={detailPageUrl}
            onClick={onBadgeClick}
            tabIndex={0}
        >
            <SVGIcon
                markup={TOUR_360__24}
                aria-hidden
                className="VirtualTourBadge__icon"
            />
            <div className="VirtualTourBadge__text-container">
                <span className="VirtualTourBadge__text">{badge.name}</span>
            </div>
        </a>
    );
}
